export default __webpack_public_path__ + "static/media/destaque2Mobile_recorte.fd349237.webp";